
import { defineComponent, PropType } from 'vue'
import { iDimension, iHierarchy, iNodeMetadata } from '../HierarchyManagement'
import { AxiosResponse } from 'axios'
import { filterDefault } from '@/helpers/commons/filterHelper'
import hierarchyManagementHierarchiesCardDescriptor from '@/modules/managers/hierarchyManagement/HierarchyManagementMasterTab/HierarchyManagementHierarchiesCard/HierarchyManagementHierarchiesCardDescriptor.json'
import hierarchyManagementDimensionsTableDescriptor from '@/modules/managers/hierarchyManagement/HierarchyManagementMasterTab/HierarchyManagementDimensionsCard//HierarchyManagementDimensionsTable/HierarchyManagementDimensionsTableDescriptor.json'
import Dropdown from 'primevue/dropdown'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'

export default defineComponent({
    name: 'hierarchy-management-technical-tab',
    components: { Dropdown, Column, DataTable },
    props: { dimensions: { type: Array as PropType<iDimension[]> } },
    data() {
        return {
            hierarchyManagementHierarchiesCardDescriptor,
            hierarchyManagementDimensionsTableDescriptor,
            selectedDimension: null as iDimension | null,
            hierarchyType: '' as string,
            selectedHierarchy: null as iHierarchy | null,
            nodeMetadata: null as iNodeMetadata | null,
            hierarchies: [] as iHierarchy[],
            backupData: [] as any,
            rows: [] as any[],
            editingRows: [] as any[],
            columns: [] as { field: string; header: string }[],
            globalFilterFields: [] as string[],
            filters: { global: [filterDefault] },
            loading: false
        }
    },
    created() {},
    methods: {
        async onSelectedDimensionChange() {
            await this.loadNodeMetadata()
        },
        async onHierarchyTypeSelected() {
            this.selectedHierarchy = null
            await this.loadHierarchies()
        },
        async onHierarchySelected() {
            await this.loadBackupData()
        },
        async loadNodeMetadata() {
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `hierarchies/nodeMetadata?dimension=${this.selectedDimension?.DIMENSION_NM}&excludeLeaf=false`).then((response: AxiosResponse<any>) => (this.nodeMetadata = response.data))
        },
        async loadHierarchies() {
            const url = this.hierarchyType === 'MASTER' ? `hierarchiesMaster/getHierarchiesMaster?dimension=${this.selectedDimension?.DIMENSION_NM}` : `hierarchiesTechnical/getHierarchiesTechnical?dimension=${this.selectedDimension?.DIMENSION_NM}`
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + url).then((response: AxiosResponse<any>) => (this.hierarchies = response.data))
        },
        async loadBackupData() {
            this.loading = true
            const url = `hierarchiesBackup/getHierarchyBkps?dimension=${this.selectedDimension?.DIMENSION_NM}&hierarchyCode=${this.selectedHierarchy?.HIER_CD}&hierarchyName=${this.selectedHierarchy?.HIER_NM}&hierarchyType=${this.selectedHierarchy?.HIER_TP}`
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + url).then((response: AxiosResponse<any>) => {
                this.rows = response.data.root
                this.columns = response.data.columns
                    ?.filter((column: any) => column.VISIBLE)
                    .map((column: any) => {
                        return { field: column.ID, header: column.NAME }
                    })
                this.globalFilterFields = response.data.columns_search
            })
            this.loading = false
        },
        deleteBackupConfirm(hierarchy) {
            this.$confirm.require({
                header: this.$t('common.delete'),
                message: this.$t('managers.hierarchyManagement.deleteBackupConfirm'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.deleteBackup(hierarchy)
            })
        },
        async deleteBackup(hierarchy) {
            const url = `hierarchies/deleteHierarchy`
            let postData = { dimension: this.selectedDimension?.DIMENSION_NM, name: hierarchy.HIER_NM }
            await this.$http.post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + url, postData).then((response: AxiosResponse<any>) => {
                if (response.data.response === 'ok') {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('managers.hierarchyManagement.backupDeleted')
                    })
                    this.loadBackupData()
                }
            })
        },
        updateBackupConfirm(event) {
            this.$confirm.require({
                header: this.$t('common.update'),
                message: this.$t('managers.hierarchyManagement.saveBackupMessage'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.updateBackup(event)
            })
        },
        async updateBackup(eventData) {
            const url = `hierarchiesBackup/modifyHierarchyBkps`
            let postData = { HIER_DS: eventData.newData.HIER_DS, HIER_NM: eventData.newData.HIER_NM, HIER_NM_ORIG: eventData.data.HIER_NM, dimension: this.selectedDimension?.DIMENSION_NM }
            await this.$http.post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + url, postData).then((response: AxiosResponse<any>) => {
                if (response.data.response === 'ok') {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.updateTitle'),
                        msg: this.$t('common.toast.success')
                    })
                    this.loadBackupData()
                }
            })
        },
        restoreBackupConfirm(backup) {
            this.$confirm.require({
                header: this.$t('managers.hierarchyManagement.restoreTitle'),
                message: this.$t('managers.hierarchyManagement.restoreMsg'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.restoreBackup(backup)
            })
        },
        async restoreBackup(backup) {
            const url = `hierarchiesBackup/restoreHierarchyBkps`
            let postData = { code: backup.HIER_CD, name: backup.HIER_NM, dimension: this.selectedDimension?.DIMENSION_NM }
            await this.$http.post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + url, postData).then((response: AxiosResponse<any>) => {
                if (response.data.response === 'ok') {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.restore'),
                        msg: this.$t('common.toast.success')
                    })
                    this.loadBackupData()
                }
            })
        }
    }
})
